"use client";

import { createContext, useContext } from "react";
import type { OrgType } from "@/lib/auth/resolve-org-type";

/**
 * Tipo de conta encenado pelo demo da home. Reusa o `OrgType` do app para que
 * os módulos compartilhados (`resolveCreatorTopView`, `applyOrgTypeLabel`)
 * recebam o mesmo valor que receberiam logados.
 */
export interface DemoOrgModeContextValue {
  orgMode: OrgType;
  isCollab: boolean;
}

/**
 * Padrão `creator`: um demo montado fora do provider (teste, storybook) fica
 * idêntico ao de antes do switch.
 */
export const DemoOrgModeContext = createContext<DemoOrgModeContextValue>({
  orgMode: "creator",
  isCollab: false,
});

export function useDemoOrgMode(): DemoOrgModeContextValue {
  return useContext(DemoOrgModeContext);
}
